import { render } from "./PartnerDashboard.vue?vue&type=template&id=f1d7d786&scoped=true"
import script from "./PartnerDashboard.vue?vue&type=script&lang=js"
export * from "./PartnerDashboard.vue?vue&type=script&lang=js"

import "./PartnerDashboard.vue?vue&type=style&index=0&id=f1d7d786&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1d7d786"]])

export default __exports__